import Ember from 'ember';
import * as runtime from '@glimmer/runtime';
import * as tracking from '@glimmer/tracking';
import * as validator from '@glimmer/validator';
import * as reference from '@glimmer/reference';
import * as destroyable from '@glimmer/destroyable';
// eslint-disable-next-line import-x/no-unresolved
import { RSVP } from '@ember/-internals/runtime';
import config from 'uplisting-frontend/config/environment';

window.define('@glimmer/tracking', () => tracking);
window.define('@glimmer/runtime', () => runtime);
window.define('@glimmer/validator', () => validator);
window.define('@glimmer/reference', () => reference);
window.define('@glimmer/destroyable', () => destroyable);
window.define('rsvp', () => RSVP);
window.define('ember', () => ({ default: Ember }));
window.define('uplisting-frontend/config/environment', () => ({
  default: config,
}));
